import router from "../router";

const state = {
	showToolbar : false,
	mapReady: false,
	roomArray: null,
	menuOpen: false,
	// "http://localhost:8080/"
	// "https://roomfinder.arizona.edu/"
	baseURL:   process.env.NODE_ENV === 'development' ? "http://localhost:8080/" : "https://roomfinder.arizona.edu/", 
	showDetail: false,
	showMap: false,
	latLong: null,
	showElevator: false,
	darkElevator: false,
	
};

const mutations = {
	setShowToolbar(state, payload) {
		state.showToolbar = payload;
	},

	setLatLong(state, payload) {
		state.latLong = payload
	},

	setMenuOpen(state, payload) {
		state.menuOpen = payload
	},

	setMapReady(state, payload) {
		state.mapReady = payload;
	},

	setShowMap(state, payload) {
		state.showMap = payload;
	},

	setRoomArray(state, payload) {
		state.roomArray = payload;
	},

	setShowDetail(state, payload) {
		state.showDetail = payload
	},

	setShowElevator(state, payload) {
		if (payload=="dark") 					{ state.showElevator = true; state.darkElevator = true;  }
		if (payload=="true" || payload==true) 	{ state.showElevator = true  }
		if (payload=="false" || payload==false) { state.showElevator = false }
		console.log("SetShowElevator", payload)
	},
	
};

const getters = {
};

const actions = {
};

export default {
	state,
	actions,
	mutations,
	getters
};